import axios from "axios";

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_URL || "http://localhost:8000",
  headers: {
    "Content-Type": "application/json",
  },
});

let currentRequestInterceptor: number | null = null;
let currentResponseInterceptor: number | null = null;

export const setupAuthInterceptor = (getToken: () => string | null) => {
  if (currentRequestInterceptor !== null) {
    apiClient.interceptors.request.eject(currentRequestInterceptor);
  }

  currentRequestInterceptor = apiClient.interceptors.request.use(
    (config) => {
      const token = getToken();
      if (token) {
        config.headers.Authorization = token;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

export const setupSignOutInterceptor = (signOut: () => void) => {
  if (currentResponseInterceptor !== null) {
    apiClient.interceptors.response.eject(currentResponseInterceptor);
  }

  currentResponseInterceptor = apiClient.interceptors.response.use(
    (response) => response,
    (error) => {
      if (
        error?.response?.status === 401 &&
        error?.response?.data?.code === "token_not_valid"
      ) {
        signOut();
        window.location.href = "/login";
      }
      if (
        error?.response?.status === 403 &&
        error?.response?.data?.code === "password_change_required" &&
        !window.location.pathname.startsWith("/force-password-change")
      ) {
        const appParam = new URLSearchParams(window.location.search).get("app");
        const dest = appParam
          ? `/force-password-change?app=${encodeURIComponent(appParam)}`
          : "/force-password-change";
        window.location.href = dest;
      }
      return Promise.reject(error);
    }
  );
};
